import { InlineChatController } from 'vscode/vscode/vs/workbench/contrib/inlineChat/browser/inlineChatController';
import { CTX_INLINE_CHAT_FOCUSED, CTX_INLINE_CHAT_RESPONSE_FOCUSED } from 'vscode/vscode/vs/workbench/contrib/inlineChat/common/inlineChat';
import { IAccessibleViewService } from 'vscode/vscode/vs/workbench/contrib/accessibility/browser/accessibleView.service';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { ICodeEditorService } from 'vscode/vscode/vs/editor/browser/services/codeEditorService';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { AccessibleViewAction } from 'vscode/vscode/vs/workbench/contrib/accessibility/browser/accessibleViewActions';

class InlineChatAccessibleViewContribution extends Disposable {
    constructor() {
        super();
        this._register(AccessibleViewAction.addImplementation(100, 'inlineChat', accessor => {
            const accessibleViewService = accessor.get(IAccessibleViewService);
            const codeEditorService = accessor.get(ICodeEditorService);
            const editor = (codeEditorService.getActiveCodeEditor() || codeEditorService.getFocusedCodeEditor());
            if (!editor) {
                return false;
            }
            const controller = InlineChatController.get(editor);
            if (!controller) {
                return false;
            }
            const responseContent = controller?.getMessage();
            if (!responseContent) {
                return false;
            }
            accessibleViewService.show({
                id: "inlineChat" ,
                verbositySettingKey: "accessibility.verbosity.inlineChat" ,
                provideContent() { return responseContent; },
                onClose() {
                    controller.focus();
                },
                options: { type: "view"  }
            });
            return true;
        }, ( ContextKeyExpr.or(CTX_INLINE_CHAT_FOCUSED, CTX_INLINE_CHAT_RESPONSE_FOCUSED))));
    }
}

export { InlineChatAccessibleViewContribution };
